module.exports = __webpack_public_path__ + "img/left-arrow.2da4352e.svg";